import { HttpMethod, Command } from "~/extensions/api";
export class FindInformationListCommand extends Command {
    constructor() {
        super(HttpMethod.Post, "information/find");
    }
}
